import { put, call, select, takeLatest, delay } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import { showLoader, hideLoader } from '../../actions/common'
import { fetchUnitSuccess, updateFilter } from '../../actions/unit/unit'
import unitActionTypes from '../../constants/actions/unit/unit'
import getUnits from '../../services/unit/getUnitList'
import messageModalActions from '../../actions/modals/messageModal'
import { handleError } from '../errors/errorManager'

export function * fetchUnits ({ filter }) {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    const response = yield call(getUnits, {
      token: auth.token,
      companyId: filter.company ? filter.company.companyId : null,
      name: filter.unitName || null,
      orderBy: filter.orderBy || null,
      page: filter.page || null,
      pageSize: filter.pageSize || null
    })
    yield put(fetchUnitSuccess(response))
    yield put(updateFilter(filter))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_DATA_FAILED'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchChangeFilter () {
  yield takeLatest(unitActionTypes.CHANGE_UNIT_FILTER, fetchUnits)
}

export function * changeFilterString ({ filter }) {
  yield call(delay, 500)
  yield * fetchUnits({ filter })
}

export function * watchChangeFilterString () {
  yield takeLatest(unitActionTypes.CHANGE_FILTER_STRING, changeFilterString)
}
